import { useSyncExternalStore } from "react";

/** Matches `$dock-sheet-breakpoint` in Assistant/_dockBreakpoint.scss. */
export const NARROW_EDITOR_BREAKPOINT = 1024;

const QUERY = `(max-width: ${NARROW_EDITOR_BREAKPOINT - 1}px)`;

// Every question card asks, so they share one media-query listener instead of one each.
const subscribe = (onChange: () => void) => {
  const list = window.matchMedia(QUERY);
  list.addEventListener("change", onChange);
  return () => list.removeEventListener("change", onChange);
};
const getSnapshot = () => window.matchMedia(QUERY).matches;

/**
 * True below 1024px. Three columns leave a tablet canvas of about 140px, so phones and tablets
 * share one layout: a full-width canvas with the palette and properties in drawers. The query
 * is read on the first render, so a narrow screen never flashes the three-column layout.
 */
export function useIsNarrowEditor(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, () => false);
}
